import { render } from "./Faqs-page.vue?vue&type=template&id=09dadb88&scoped=true"
import script from "./Faqs-page.vue?vue&type=script&lang=js"
export * from "./Faqs-page.vue?vue&type=script&lang=js"

import "./Faqs-page.vue?vue&type=style&index=0&id=09dadb88&lang=scss&scoped=true"
import "./Faqs-page.vue?vue&type=style&index=1&id=09dadb88&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09dadb88"]])

export default __exports__